const jQuery = require('jquery');
const _ = require('lodash');

let RteConfig = require('./config');

const container = require('./../../core/container');
const mediator = require('./../../core/mediator');
const fixCke = require('./fix');

require('./plugins/colorsPanel');
require('./plugins/nbsp/plugin');

let active = null;
let instance;

const destroy = function(config) {
  config.instance = config.instance || instance;
  config.$element = config.$element || active.$element;

  mediator.publish('before:rte:destroy', config);

  if (config.instance) {
    config.instance.destroy();
  }

  active.$element.removeAttr('contenteditable');
  active.$element.removeClass('cloud-rte-enabled');
  active = null;
  instance = null;

  mediator.publish('after:rte:destroy', config);

  return false;
};

const restore = function(config) {
  let content = config.content;

  content.$.html(content.currentRteValue);
  destroy(config);

  return false;
};

const create = function(config) {
  if (active || container.get('ui_status') === 'disabled') {
    return;
  }

  config.buttons = RteConfig.buttons;
  config.config = RteConfig.config;

  active = config;
  active.$container = active.$container || active.$element;
  active.$element.addClass('cloud-rte-enabled');
  mediator.publish('before:rte:create', config);

  _.merge(CKEDITOR.config, RteConfig.buttons);
  active.$element.attr('contenteditable', true);

  let fontSizeData = active.$element.attr('data-font-size') || 'px';
  if (fontSizeData && RteConfig.fontSize[fontSizeData]) {
    RteConfig.config['fontSize_sizes'] = RteConfig.fontSize[fontSizeData];
  } else {
    delete RteConfig.config['fontSize_sizes'];
  }

  fixCke.fix();

  let settings = RteConfig.config;
  mediator.publish('before:rte:config', settings);

  CKEDITOR.disableAutoInline = true;
  CKEDITOR.inline(active.$element.get(0), settings);
  CKEDITOR.once('currentInstance', function() {
    instance = CKEDITOR.currentInstance;

    if (instance) {
      let $instance = jQuery('#cke_' + instance.ui.editor.name);

      $instance.addClass('cloud-cke');

      config.instance = instance;

      if (container.get('isMobile')) {
        let $confirm = jQuery('<div class="confirm-rte"><button class="ok"><i class="icon icon-check"></i></button><button class="cancel"><i class="icon icon-times"></i></button></div>');

        $confirm.on('touchstart', 'button.cancel', restore.bind(undefined, config));
        $confirm.on('touchstart', 'button.ok', destroy.bind(undefined, config));

        $confirm.insertBefore($instance.find('.cke_inner'));

        $instance.find('.cke_toolbar').on('click', function() {
          let $rte = jQuery('.cke');

          $rte.css('position', 'absolute');
          $rte.css('top', window.pageYOffset);
          $rte.css('opacity', '1');
        });
      } else {
        instance.on('blur', destroy.bind(undefined, config));
        instance.on('change', mediator.publish.bind(mediator, 'on:rte:change', config));
      }
    }
  });

  CKEDITOR.ui.on('ready', function() {
    jQuery('iframe.cke_panel_frame').contents().find('head').append(jQuery('#cloud-css').clone().get(0));
  });

  mediator.publish('after:rte:create', config);
};

module.exports.create = create;
module.exports.destroy = destroy;
module.exports.getCurrentInstance = instance;
module.exports.restore = restore;
